<template>
    <div class="biz-view-house">
        <div class="biz-view-house-head">
            <h1 class="page-title">{{houseDefault.houseDataEditDto.name}}</h1>
            <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                <ul >
                    <li>合約政策版本</li> 
                    <li>費用版本</li> 
                    <li>更新所有房源</li> 
                </ul>
            </dot-large-drop-menu >
        </div>
        <div class="user-info">
            <span class="title">租客</span>
            <div class="group">
                <span v-if="tenant.name" class="name">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    租客：{{tenant.name}}
                </span>
                <span v-else class="name">
                    <img src="@/assets/img/icon/user_shot_black.svg" alt="">
                    尚無租客
                </span>
                <div class="status">
                    狀態：
                    <span v-if="houseDefault.complete">已完善</span>
                    <span v-else>未完善</span>
                    <span v-if="houseDefault.houseDataEditDto.publish">、上架</span>
                    <span v-else>、下架</span>
                </div>
            </div>
            
        </div>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                分群與負責人
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            業務分群
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.groupName?houseDefault.houseDataEditDto.groupName:'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            負責人
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.agentName?houseDefault.houseDataEditDto.agentName:'無'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房源說明
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="image-group">
                    <div class="list">
                        <img :src="imageUrl(houseDefault.houseDataEditDto.houseCoverImage)" alt="">
                        <div class="cover">
                            封面
                        </div>
                    </div>
                    <div class="list" v-for="(item, index) in houseDefault.houseDataEditDto.houseImageListList" :key="index">
                        <img :src="imageUrl(item)" alt="">
                    </div>
                </div>
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            廣告標題
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.name?houseDefault.houseDataEditDto.name:'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房屋租金
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.rentMonthly?houseDefault.houseDataEditDto.rentMonthly:'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源介紹
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.description?houseDefault.houseDataEditDto.description:'無'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房源類型
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            出租類型
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.buildingType?buildingType(houseDefault.houseDataEditDto.buildingType):'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源格局
                        </div>
                        <div class="biz-table-content">
                            <span v-if="houseDefault.houseDataEditDto.houseType == 1">{{houseDefault.houseDataEditDto.housePatternDto.bedroom}}房{{houseDefault.houseDataEditDto.housePatternDto.sharedRoom}}廳{{houseDefault.houseDataEditDto.housePatternDto.bathroom}}衛浴{{houseDefault.houseDataEditDto.housePatternDto.balcony}}陽台</span>
                            <span v-else>{{houseDefault.houseDataEditDto.roomPatternDto.hasBalcony?'有':'無'}}陽台{{houseDefault.houseDataEditDto.roomPatternDto.hasDuplex?'有':'無'}}閣樓</span>
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房屋類型
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.houseType?houseType(houseDefault.houseDataEditDto.houseType):'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源坪數
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.size?houseDefault.houseDataEditDto.size:'無'}} 坪
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            特殊樓層
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.specialType?specialType(houseDefault.houseDataEditDto.specialType):'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源樓層
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.floor?houseDefault.houseDataEditDto.floor:'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            最短租期
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.shortestPeriod?houseDefault.houseDataEditDto.shortestPeriod+' 個月':'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            與屋主同住
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.withLandlord?'是':'否'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            最快起租日
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.moveInDate?getFormatDateTime(houseDefault.houseDataEditDto.moveInDate):'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房源地址
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.address?houseDefault.houseDataEditDto.address:'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            租金包含
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.rentInclude?getHouseSetting(houseDefault.houseDataEditDto.rentInclude):'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            提供設備
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.equipment?getHouseSetting(houseDefault.houseDataEditDto.equipment):'無'}}
                        </div>
                    </div>
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            使用規範
                        </div>
                        <div class="biz-table-content">
                            {{houseDefault.houseDataEditDto.rules?getHouseSetting(houseDefault.houseDataEditDto.rules):'無'}}
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block class="policy-contract">
            <div class="toogle-title policy" slot="toogle-title">
                自訂合約條款
                <div class="view-default">
                    <router-link :to="{ name: 'bizDefaultPolicy'}" target="_blank">
                        <img src="@/assets/img/icon/view_gray.svg" alt="">
                        預設條款
                    </router-link>
                </div>
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="policy-content">
                    <div v-if="houseDetail.housePolicy.length == 0">
                        無
                    </div>
                    <div class="list" v-for="(item, index) in houseDetail.housePolicy" :key="index">
                        {{item}}
                    </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                房東資訊
            </div>
            <div class="toogle-body" slot="toogle-body">
                <div class="biz-table">
                    <div class="biz-table-row">
                        <div class="biz-table-title">
                            房東
                        </div>
                        <div class="biz-table-content">
                            <span v-if="houseDefault.houseDataEditDto.realLandlordName">
                                {{houseDefault.houseDataEditDto.realLandlordName}}．{{houseDefault.houseDataEditDto.realLandlordPhone?houseDefault.houseDataEditDto.realLandlordPhone:'未輸入電話'}}
                            </span>
                            <span v-else>
                                無
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import constant from '@/constant'
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiBizGetEditHouseList
} from "@/apis/api.js"; 
export default {
    data () {
        return {
            houseDetail: null,
            houseDefault: null,
            tenant: {
                cid: null,
                name: null,
            },
        }
    },
    mounted () {
        this.getHouseInfo(this.$route.query.cid)
        this.getHouseDefault(this.$route.query.cid)
    },
    methods: {
        getContractTenant: function (contractCid) {
            let data = contractCid
            apiBizGetContractTenant(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.tenant.cid = res.data.result.tenantCid
                    this.tenant.name = res.data.result.tenantName
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getHouseDefault (hid) {
            let data = hid
            apiBizGetEditHouseList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.houseDefault = res.data.result
                    let contractCid = res.data.result.houseDetail.contractCid
                    if(contractCid){
                        this.getContractTenant(contractCid)
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getHouseInfo: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then( res => {
                console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.houseDetail = res.data.result.houseDetail
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        imageUrl: function (url) {
            return constant.imageUrl+url
        },
    },
    components: {
        toogleBlock,
        DotLargeDropMenu
    }
}
</script>
<style lang="scss" scoped>
    .biz-view-house{
        .biz-view-house-head{
            position: relative;
            margin-top: 0px;
            margin-bottom: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .user-info{
            position: relative;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 20px;
            border-radius: 6px;
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                padding: 0 24px;
                height: 100%;
                color: #a8a5a4;
                border-right:1px solid #f1f5f4;
            }
            .group{
                width: 100%;
                padding: 0 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .name{
                    display: flex;
                    align-items: center;
                    margin-right: 18px;
                    img{
                        width: 30px;
                        margin-right: 8px;
                    }
                }
            }
            
        }
        .biz-table-content{
            width: 80%;
        }
        .image-group{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 20px;
            .list{
                position: relative;
                width: 124px;
                height: 93px;
                display: flex;
                align-items: center;
                border-radius: 4px;
                overflow: hidden;
                margin-right: 10px;
                margin-bottom: 10px;
                >img{
                    width: 100%;
                }
                .cover{
                    position: absolute;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 7px 0;
                    bottom: 0;
                    font-size: 12px;
                    color: #ffffff;
                    background-color: #676362;
                }
                &:nth-child(8){
                    margin-right: 0px;
                }
            }
        }
        .policy-contract{
            .policy{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                .view-default{
                    font-size: 14px;
                    color: #676362;
                    position: relative;
                    right: 45px;
                    a{
                        display: flex;
                        align-items: center;
                    }
                }
            }
            .policy-title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 16px;
            }
            .list{
                width: 660px;
                margin-bottom: 16px;
                line-height: 1.5;
                &:last-child{
                    margin-bottom: 0px;
                }
            }
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/viewHouse/viewHouseComp.vue